import { useMemo } from "react";

import { useSelector } from "react-redux";

import {
    StyledContactsActionsPanel,
    StyledInnerContainer,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/components/ContactsTableActionsPanel/styles";
import ContactsRevealActionButtonContainer from "app/pages/sales-intelligence/sub-modules/contacts-search/containers/ContactsRevealActionButton";
import LeadsSearchExportAllContactsButtonContainer from "app/pages/sales-intelligence/sub-modules/contacts-search/containers/LeadGenExportAllContactsButton/LeadsSearchExportAllContactsButtonContainer";
import {
    useContactSearchResult,
    useInvalidateContactSearchResultAsync,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/hooks/useContactSearchResult";
import {
    selectAreAnyContactsFiltersApplied,
    selectIsPanelExportActive,
    selectMultipleRevealIsInProgress,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";

import ContactsExportPanelContainer from "../../table-actions-panel/ContactsExportPanel/ContactsExportPanelContainer";
import ContactsRevealPanelContainer from "../../table-actions-panel/ContactsRevealPanel/ContactsRevealPanelContainer";
import ContactsExportVariantsDropdownContainer from "../ExportVariantsDropdown/ContactsExportVariantsDropdownContainer";

const ContactsTableActionsPanelContainer = () => {
    const areContactsFiltersApplied = useSelector(selectAreAnyContactsFiltersApplied);
    const invalidateContactSearchResult = useInvalidateContactSearchResultAsync();
    const isExportFlowActive = useSelector(selectIsPanelExportActive);
    const isMultipleRevealInProgress = useSelector(selectMultipleRevealIsInProgress);

    const { data, isFetching } = useContactSearchResult();

    const defaultActiveChild = useMemo(() => {
        if (isExportFlowActive) {
            return ContactsExportPanelContainer;
        }
        if (isMultipleRevealInProgress) {
            return ContactsRevealPanelContainer;
        }
        return undefined;
    }, [isExportFlowActive, isMultipleRevealInProgress]);

    const ExportButton = !areContactsFiltersApplied
        ? LeadsSearchExportAllContactsButtonContainer
        : ContactsExportVariantsDropdownContainer;

    return (
        <StyledContactsActionsPanel defaultActiveChild={defaultActiveChild}>
            {({ activate }) => {
                function activateRevealPanel() {
                    activate(() => ContactsRevealPanelContainer);
                }

                return (
                    <StyledInnerContainer>
                        <ContactsRevealActionButtonContainer
                            isLoading={isFetching}
                            numberOfResults={data?.totalCount ?? 0}
                            onClick={activateRevealPanel}
                            onApprove={invalidateContactSearchResult}
                        />
                        <ExportButton onActivate={activate} />
                    </StyledInnerContainer>
                );
            }}
        </StyledContactsActionsPanel>
    );
};

export default ContactsTableActionsPanelContainer;
